import { Component, Input } from '@angular/core';

@Component({
	selector: 'users-permissions',
	templateUrl: './users-permissions.component.html',
	styleUrls: ['./users-permissions.component.scss'],
})
export class UsersPermissionsComponent {
	@Input() edit = false;
}
